import React from 'react';
import SurveyContainer from '../../../Containers/Survey/Survey.container';

const Survey = (props) => <SurveyContainer id="tc_survey_modal" {...props} />;

export default Survey;
